module.exports = __webpack_public_path__ + "static/9-timbernerslee-1989-3663c9262b37e34972af9a2a8b2309b5.jpg";